/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import { FastApiErrorResponse } from "@/api/base";

interface Props {
  refetch: () => void;
  error: unknown;
  setShowLoading: React.Dispatch<React.SetStateAction<boolean>>;
  showLoading: boolean;
}

export const ChronologyTimelinesRefresh: React.FC<Props> = ({ refetch, error, showLoading, setShowLoading }) => {
  React.useEffect(() => {
    let timeout: number | null = null;
    if (error && (error as any).status === 404) {
      return;
    }

    const errorData = (error as FastApiErrorResponse)?.data?.data;

    if (
      errorData &&
      ["Document has not chronology", "Folder must have a chronology", "Document must have a chronology"].includes(
        errorData[0],
      )
    ) {
      setShowLoading(true);
      timeout = setTimeout(() => {
        refetch();
      }, 10000);
    } else if (showLoading) {
      setShowLoading(false);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [error, showLoading, setShowLoading, refetch]);

  return null;
};
